import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import InstagramLogo from 'resources/common/instagram.svg';
import PolicyModal from 'components/common/PolicyModal';

const Footer = () => {
  const location = useLocation();

  // 모달 여닫기 
  const [openModal, setOpenModal] = useState(false);
  const openModalHandler = () => {
    setOpenModal(!openModal);
  }

  // 동의서 내부에 보기 버튼 클릭시 모달타입설정
  const [modalType, setModalType] = useState();
  const chooseModalType = (id) => {
    setModalType(id);
    setOpenModal(!openModal);
  }

  if (location.pathname !== '/login' && location.pathname !== '/join' && location.pathname !== '/welcomeSignup') { 
    return (
      <>
        <FooterContainer>
          <FooterItems>
            <Item>
              <li>(주)브리피</li>
              <li>대표: 신영욱</li>
              <li>주소: 서울특별시 종로구 효자로 15, 4층</li>
              <li>사업자등록번호: 822-87-01977 | 개인정보보호책임: 서욱진</li>
              <li>통신판매번호: 2022-서울종로-0701</li>
              <li>E-MAIL: contact@briphy.com</li>
              <li style={{fontSize: '12px', marginTop: '25px'}}>Copyright © 2023 briphy. All rights reserved</li>
            </Item>
            <Item>
              <li>고객센터</li>
              <li className='hpNo'>02-6925-4411</li>
              <li>상담시간 10:00 ~ 18:00</li>
              <li>점심시간 12:00 ~ 14:00</li>
              <li>주말/공휴일 휴무</li>
            </Item>
            <Item>
              <li></li>
              <li className='menu'><Link to={'/terms/1'}>이용약관</Link></li>
              <li className='menu'><Link to={'/privacy'}>개인정보처리방침</Link></li> 
              <li className='menu'><a href="https://www.instagram.com/briphy.kr" target='_blank'><Instagram src={InstagramLogo} /></a></li>
            </Item>
          </FooterItems>
        </FooterContainer>
        <MobileFooter>
          <MobileContainer>
            <MobileItemWrapper>
              <MobileItem className='mfl'>
                <li>(주)브리피</li>
                <li>대표: 신영욱</li>
                <li>주소: 서울특별시 종로구 효자로 15, 4층</li>                
                <li>사업자등록번호: 822-87-01977</li>
                <li>개인정보보호책임: 서욱진</li>
                <li>E-MAIL: contact@briphy.com</li>
                <li style={{display: 'flex'}}>
                  <div>통신판매번호: </div>
                  <div>2022-서울종로-0701</div>
                </li>
              </MobileItem>
              <MobileItem className='mfr'>
                <li>고객센터</li>
                <li>02-6925-4411</li>
                <li>상담시간 10:00 ~ 18:00</li>
                <li>점심시간 12:00 ~ 14:00</li>
                <li>주말/공휴일 휴무</li>
              </MobileItem>
            </MobileItemWrapper>
            <LineBox>
              <OtherItem>
                <span className='link' onClick={() => chooseModalType('terms/1')}>이용약관</span> |
                <span className='link' onClick={() => chooseModalType('privacy')}>개인정보처리방침</span> |
                <span><a href="https://www.instagram.com/briphy.kr" target='_blank'><Instagram src={InstagramLogo} width={15} /></a></span>
              </OtherItem>
            </LineBox>
            <CopyRight>Copyright © 2023 briphy. All rights reserved.</CopyRight>
          </MobileContainer>
        </MobileFooter>

        <PolicyModal
          modal={openModal}
          handleModal={openModalHandler}
          type={modalType}
        />
      </> 
    )
  }
}

export default Footer;

const FooterContainer = styled.footer`
  display: flex;
  // position: relative;
  // position: absolute;
  background-color: ${props => props.theme.bgColorBlack};
  color: white;
  width: 100%;

  ul:nth-child(1) {
    flex: 0.4;
  }

  ul:nth-child(2) {
    flex: 0.4;
  }

  ul:nth-child(3) {
    flex: 0.2;
  }

  @media ${({theme}) => theme.device.mobile} {
    display:none;
  }
`;

const FooterItems = styled.div`
  display: flex;
  width: 1088px;
  padding: 22px 15px;
  margin: 0 auto;
`;

const Item = styled.ul`
  flex: 1;
  list-style-type: none;
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
  
  li:first-child {    
    font-size: 16px;
    font-weight: 800;
    line-height: 2;
  }

  .hpNo {
    font-size: 24px;
    font-weight: 400;
    line-height: 29px;
  }
  
  .menu {
    font-size: 16px;
    font-weight: 400;
    line-height: 2.5;
  }
`;

const Instagram = styled.img`
  cursor: pointer;
  vertical-align: middle;
  width: ${props => props.width ? `${props.width}px` : ''};
  height: ${props => props.width ? `${props.width}px` : ''};
`

// Mobile Style
const MobileFooter = styled.footer`
  display: none;
  background-color: #000000;
  color: white;
  position: relative;
  width: 100%;
  
  @media ${({theme}) => theme.device.mobile} {
    display: block;
  }
`;

const MobileContainer = styled.div`
  display: flex;
  margin: 0 auto;
  padding: 15px 16px 10px;
  flex-direction: column;
`;

const MobileItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  ul + ul {
    margin-left: 30px;
  }

  .mfl {
    flex: 0.6;
  }

  .mfr {
    flex: 0.4;
  }
`;

const MobileItem = styled.ul`
  line-height: 15px;
  font-size: 11px;

  li:first-child {
    font-size: 14px;
    font-weight: 800;
    text-align: left;
    margin-bottom: 5px;
  }
`;

const LineBox = styled.div`
  width: 100%;
  margin: 7px auto;
  border-top: 0.25px solid #FFFFFF;
  border-bottom: 0.25px solid #FFFFFF;
`

const OtherItem = styled.div`  
  margin: 5px auto;
  font-size: 13px;
  font-weight: 700;
  line-height: 12px;


  span {
    margin-right: 10px;
  }

  span:not(:first-child) {
    margin-left: 10px;
  }

  .link {
    font-size: 13px;
    font-weight: 700;
    line-height: 16px;
  }

  img {
    margin-top: -1px;
  }
`

const CopyRight = styled.div`
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
`

